import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import Navigation from "@/components/Navigation";
import StatCards from "@/components/StatCards";
import ConversionWaterfall from "@/components/ConversionWaterfall";
import ReverseMathCalculator from "@/components/ReverseMathCalculator";
import RevenueStatusBar from "@/components/RevenueStatusBar";
import { Loader2 } from "lucide-react";

export default function Dashboard() {
  const { data: stats, isLoading } = useQuery({
    queryKey: ["stats"],
    queryFn: async () => (await api.get("/stats")).data,
  });

  return (
    <div className="gos-canvas min-h-screen">
      <Navigation />
      <main className="max-w-[1400px] mx-auto px-4 sm:px-6 py-8 space-y-6">
        <div className="fade-up">
          <p className="eyebrow mb-2">AEO Agency by Smart Marketer · Command Centre</p>
          <h1 className="font-display text-3xl lg:text-4xl font-bold text-white tracking-tight">Pipeline Dashboard</h1>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center py-32">
            <Loader2 className="w-8 h-8 text-indigo-400 animate-spin" />
          </div>
        ) : (
          <>
            <StatCards stats={stats} />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <ConversionWaterfall stats={stats} />
              <ReverseMathCalculator stats={stats} />
            </div>
            <RevenueStatusBar stats={stats} />
          </>
        )}
      </main>
    </div>
  );
}
